import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

/**
 * PageNotFoundComponent — 404 catch-all della SPA.
 *
 * Attivata dalla route wildcard `path: '**'` in `AppRoutingModule`.
 * Ridisegnata in v2.14.4: la versione precedente era hardcoded con
 * `body { background: ... }` (anti-pattern side-effect globale),
 * cerchi animati random senza semantica e zero navigazione. Nuova
 * versione:
 *   • usa solo design token — dark-mode compatible out-of-the-box,
 *   • CTA primary "Torna alla dashboard" + secondary "Vai indietro"
 *     via `Location.back()`,
 *   • illustration SVG inline warehouse-themed (scatola + '?')
 *     — coerente col dominio Diakonix,
 *   • micro-animazioni sobrie (fade+slide entry, float bobbing),
 *   • zero side-effect sul body, layout confinato a `:host`.
 */
@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: false,
})
export class PageNotFoundComponent {
  private readonly router = inject(Router);
  private readonly location = inject(Location);

  /** URL requested che ha triggerato la wildcard (per contesto UX). */
  public readonly attemptedUrl = this.router.url;

  goHome(): void {
    this.router.navigate(['/']);
  }

  goBack(): void {
    // Se non c'è history (es. link aperto in nuovo tab), fallback a home.
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.goHome();
    }
  }
}
